import { BaseQueryFn, FetchArgs, fetchBaseQuery, FetchBaseQueryError } from '@reduxjs/toolkit/query/react'
import { readToken } from './token'
import { logout, tokenRefreshed } from '../store/auth/authSlice'
import { refreshTokenRequest } from '../api/auth'
import { Mutex } from 'async-mutex'

const mutex = new Mutex()
export const baseQueryWithTokenRefresh = (baseUrl: string): BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> => {
  const baseQuery = fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers, { getState }) => {
      const token = readToken()
      if (token) {
        headers.set('Authorization', `Bearer ${token.accessToken}`)
      }
      return headers
    },
  })
  return async (args, api, extraOptions) => {
    let token = readToken()
    if (token) {
      if (token.isAccessTokenExpired && token.isRenewable) {
        await refreshLock(async () => {
          const response = await refreshTokenRequest(token!.accountId, token!.refreshToken!)
          api.dispatch(tokenRefreshed(response))
        })
      }
    } else {
      api.dispatch(logout({}))
    }
    return baseQuery(args, api, extraOptions)
  }
}

export const refreshLock = async (callback: () => Promise<any> | any, m: Mutex = mutex) => {
  if (!m.isLocked()) {
    const release = await m.acquire()
    try {
      await callback()
    } finally {
      release()
    }
  } else {
    await m.waitForUnlock()
  }
}
